let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2A55e"), load("e9Lfg"), load("bZeLH"), load("3kHns"), load("3JzPO"), load("dezv5")]).then(() => parcelRequire('hD4yV'));